// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import { mediaQueries } from "../../utils/theme/media-queries"

import { colors } from "../../utils/theme/colors"
import { fontWeights } from "../../utils/theme/font-weights"
import Button from "../button"
import Img from "gatsby-image"
import { useStaticQuery, graphql, Link } from "gatsby"
import Container from "../layout/container"
import content from "../../content/agence-amazon/get-support.json"
import Span from "../common/span"

const GetSupport = ({ langKey }) => {
  const data = useStaticQuery(graphql`
    query AgenceGetSupportQuery {
      Cards: file(relativePath: { eq: "AgenceAmazonGetSupport.png" }) {
        childImageSharp {
          # Other options include height (set both width and height to crop),
          # grayscale, duotone, rotate, etc.
          fixed(width: 780, height: 590) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      CardsMobileFluid: file(
        relativePath: { eq: "AgenceAmazonGetSupport.png" }
      ) {
        childImageSharp {
          # Other options include height (set both width and height to crop),
          # grayscale, duotone, rotate, etc.
          fluid(maxWidth: 210) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const { title1, title2, paragraph, button } = content[langKey]

  return (
    <Container>
      <div
        sx={{
          display: `flex`,
          flexDirection: `column`,

          [mediaQueries.lg]: {
            marginTop: `10rem`,
            marginBottom: `-3rem`,
            justifyContent: `space-between`,
          },
        }}
      >
        <div
          sx={{
            display: `block`,
            marginTop: `3rem`,
            justifyContent: `center`,
            [mediaQueries.lg]: {
              display: `none`,
            },
          }}
        >
          <Img fluid={data.CardsMobileFluid.childImageSharp.fluid} alt="" />
        </div>

        <div
          sx={{
            display: `flex`,
            flexDirection: `column`,
            [mediaQueries.lg]: {
              width: `45%`,
            },
          }}
        >
          <h2
            sx={{
              fontSize: [`1.38rem`, `1.38rem`, `2.25rem`, `2.25rem`],
              fontWeight: fontWeights.black,
              color: colors.code.secondary,
              textAlign: [`center`, `center`, `left`, `left`],
              [mediaQueries.lg]: {
                width: `70%`,
              },
            }}
          >
            {title1} &nbsp;
            <Span text={title2} />
          </h2>
          <p
            sx={{
              lineHeight: 1.47,
              fontSize: `0.94rem`,
              textAlign: [`center`, `center`, `left`, `left`],
              color: colors.code.secondary,
              [mediaQueries.lg]: {
                width: `73%`,
              },
            }}
          >
            {paragraph}
          </p>

          <Link
            to={
              langKey === "en"
                ? "/amazon-analytics-software/"
                : `/${langKey}/amazon-analytics-software/`
            }
            sx={{
              color: colors.code.secondary,
              marginBottom: [`3rem`, `3rem`, `6rem`, `6rem`],
              [mediaQueries.lg]: {
                width: `70%`,
              },
            }}
          >
            <Button>{button}</Button>
          </Link>
        </div>
        <div
          sx={{
            display: `none`,
            [mediaQueries.lg]: {
              display: `flex`,
              position: `absolute`,
              zIndex: 3,
              left: `35%`,
              bottom: `-2%`,
            },
          }}
        >
          <Img fixed={data.Cards.childImageSharp.fixed} alt="" />
        </div>
      </div>
    </Container>
  )
}

export default GetSupport
